import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface ProtectedRouteProps {
  students: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ students }) => {
  const { isAuthenticated, token } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // If we have a token but not authenticated, set authenticated to true
  useEffect(() => {
    if (token && !isAuthenticated) {
      // You might want to validate the token here
      // For now, we'll just trust the token
    }
  }, [token, isAuthenticated]);

  if (!token) {
    // Redirect to login but save the attempted url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{students}</>;
};

export default ProtectedRoute; 